"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleButton = void 0;
var react_1 = __importStar(require("react"));
var __1 = require("../");
var ToggleButton = function (_a) {
    var className = _a.className, isTouchScreen = _a.isTouchScreen, isDisplaySmall = _a.isDisplaySmall, openOnLargeDisplay = _a.openOnLargeDisplay, openOnSmallDisplay = _a.openOnSmallDisplay, open = _a.open, close = _a.close, onPointerEnter = _a.onPointerEnter, onPointerLeave = _a.onPointerLeave;
    var isCollapseButton = (isDisplaySmall && openOnSmallDisplay) ||
        (!isDisplaySmall &&
            openOnLargeDisplay.value &&
            !openOnLargeDisplay.temporary);
    var iconName = isCollapseButton
        ? 'keyboard_arrow_left'
        : 'keyboard_arrow_right';
    var size = isTouchScreen ? 'medium' : 'small';
    var pointerId = react_1.useRef();
    var getTooltipText = function () {
        if (isCollapseButton)
            return 'Close sidebar';
        if (!isDisplaySmall && openOnLargeDisplay.temporary)
            return 'Keep sidebar open';
        return 'Open sidebar';
    };
    var handlePointerDown = function (e) {
        pointerId.current = e.pointerId;
    };
    var handlePointerUp = function (e) {
        if (e.pointerId === pointerId.current) {
            isCollapseButton ? close() : open({ temporary: isDisplaySmall });
            pointerId.current = undefined;
        }
    };
    return (react_1.default.createElement(__1.Tooltip, { portal: true, hoverOnly: true, className: "Sidebar__toggle-button-wrapper", direction: "r", text: getTooltipText(), onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave },
        react_1.default.createElement(__1.Button, { className: className, iconName: iconName, size: size, onPointerDown: handlePointerDown, onPointerUp: handlePointerUp, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave })));
};
exports.ToggleButton = ToggleButton;
//# sourceMappingURL=ToggleButton.js.map